<ng-progress ngProgressRouter></ng-progress>
<router-outlet></router-outlet>
@if (previewData) {
  <app-image-preview-modal
    [imageUrl]="previewData.imageUrl"
    [imageName]="previewData.imageName"
    (closed)="closeImagePreview()">
  </app-image-preview-modal>
}
